import { Model } from "@vuex-orm/core";
import ToolState from "./ToolState";
import { required, maxLength } from "vuelidate/lib/validators";
import ToolProcess from "./ToolProcess";

export default class Tool extends Model {
  static entity = "tools";

  static $fetch() {
    return this.api().get('Tools/?archived=false')
  }
  static $get (name) {
    return this.api().get(`Tools/${name}/`)
  }
  static $post (data) {
    return this.api().post(`Tools/`, data)
  }
  static $put (name, data) {
    return this.api().put(`Tools/${name}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(""),
      r_and_d: this.boolean(false),
      configuration: this.string(""),
      state: this.belongsTo(ToolState, "toolstate_id"),
      archived: this.boolean(false),
      toolstate_id: this.attr(null),
      toolprocess: this.hasMany(ToolProcess, "tool_id"),
      imagesource: this.string(
        "https://secureservercdn.net/50.62.175.49/i0f.de5.myftpupload.com/wp-content/uploads/2016/09/ForgeNano_Castner_04-1.jpg"
      )
    };
  }

  toCreatePayload() {
    return {
      configuration: this.configuration,
      state: this.toolstate_id,
      name: this.name
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }

  static get validations() {
    return {
      formdata: {
        configuration: { required, maxLength: maxLength(1000) },
        toolstate_id: { required }
      }
    };
  }
}
